import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import {
  CompanyReportsTransportModesListQueryResult,
  useCompanyReportsTransportModesList,
} from '@shared/api/lib/company-reports/company-reports';
import { CompanyReportsTransportModesListParams } from '@shared/api/types';

export const useGetTransportModes = ({
  params,
}: {
  params?: CompanyReportsTransportModesListParams;
}) => {
  return useCompanyReportsTransportModesList<CompanyReportsTransportModesListQueryResult>(
    params,
    {
      request: useAxiosConfig(),
      query: {
        staleTime: Infinity,
        keepPreviousData: true,
        cacheTime: 1000 * 60 * 60 * 24, // 24 hours
      },
    }
  );
};
